"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHasUserExceededEmbeddableVideoLimit = exports.getAttemptedVideoUploadsCount = exports.getUsedEmbeddableVideoCount = exports.getEmbeddableVideoLimit = void 0;

var _reselect = require("reselect");

var _Constants = require("../Constants");

var getEmbeddableVideoLimit = function getEmbeddableVideoLimit(state) {
  return state.limits.getIn([_Constants.Limits.EMBEDDABLE_VIDEO, 'quantityAllowed']);
};

exports.getEmbeddableVideoLimit = getEmbeddableVideoLimit;

var getUsedEmbeddableVideoCount = function getUsedEmbeddableVideoCount(state) {
  return state.limits.getIn([_Constants.Limits.EMBEDDABLE_VIDEO, 'quantityUsed']);
};

exports.getUsedEmbeddableVideoCount = getUsedEmbeddableVideoCount;

var getAttemptedVideoUploadsCount = function getAttemptedVideoUploadsCount(state) {
  return state.limits.getIn([_Constants.Limits.EMBEDDABLE_VIDEO, 'attemptedVideoUploads']);
};

exports.getAttemptedVideoUploadsCount = getAttemptedVideoUploadsCount;
var getHasUserExceededEmbeddableVideoLimit = (0, _reselect.createSelector)([getEmbeddableVideoLimit, getUsedEmbeddableVideoCount], function (limit, used) {
  return used >= limit;
});
exports.getHasUserExceededEmbeddableVideoLimit = getHasUserExceededEmbeddableVideoLimit;